import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { api } from '../utils/WebApiConfig';
import { handleError, handleSuccess, handleInfo } from '../utils/Toastify';
import { useHistory } from 'react-router-dom';
import {
  Times,
  Search,
  Save,
  Edit,
  Trash,
  FileMedicalAlt,
  AngleDoubleLeft,
} from '../utils/Fontawesome';
import { TablePagination } from '@material-ui/core';
import {
  sqlLIKE,
  removeAcento,
  mask_tel_celular_area,
  mask_data,
} from '../utils/Mascara';
const FilaEspera = () => {
  let history = useHistory();

  const [fila_espera_id, setFila_espera_id] = useState('');
  const [statusFila_espera_med_id, setStatusFila_espera_med_id] = useState([]);
  const [fila_espera_hora_ini, setFila_espera_hora_ini] = useState('');
  const [fila_espera_hora_fim, setFila_espera_hora_fim] = useState('');
  const [fila_espera_contato, setFila_espera_contato] = useState('');
  const [fila_espera_observacao, setFila_espera_observacao] = useState('');
  const [fila_espera_pac_nome, setFila_espera_pac_nome] = useState('');
  const [fila_espera_med, setFila_espera_med] = useState('');

  const [filaEspera, setFilaEspera] = useState([]);
  const [nomeModal, setNomeModal] = useState('');
  const [idModal, setIdModal] = useState('');

  // variaveis da paginaçãp
  const [arrayFiltrado, setArrayFiltrado] = useState('');
  const [busca, setBusca] = useState('');
  const [filaEsperaPag, setFilaEsperaPag] = useState([]);

  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = async (event, newPage) => {
    await setPage(newPage);

    var inicio = newPage * rowsPerPage + 1;
    var fim = inicio + (rowsPerPage - 1);
    /*  console.log(
      "rowsPerPage:" +
        rowsPerPage +
        " newPage " +
        newPage +
        " " +
        inicio +
        " ---- " +
        fim
    );*/
    if (fim > arrayFiltrado.length) {
      fim = arrayFiltrado.length;
    }
    const usuariosPag = [];
    for (let i = inicio - 1; i < fim; i++) {
      usuariosPag.push(arrayFiltrado[i]);
    }
    setFilaEsperaPag(usuariosPag);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);

    var inicio = 0 * event.target.value + 1;
    var fim = inicio + (event.target.value - 1);
    if (fim > arrayFiltrado.length) {
      fim = arrayFiltrado.length;
    }
    const usuariosPag = [];
    for (let i = inicio - 1; i < fim; i++) {
      usuariosPag.push(arrayFiltrado[i]);
    }
    setFilaEsperaPag(usuariosPag);
  };
  useEffect(() => {
    if (document.getElementsByClassName('modal-backdrop')[0]) {
      var no = document.getElementsByClassName('modal-backdrop')[0];
      if (no.parentNode) {
        no.parentNode.removeChild(no);
      }
    }
    window.$('#sidebarCollapse').on('click', function () {
      window.$('#sidebar').toggleClass('active');
      window.$(this).toggleClass('active');
    });

    getFilaEspera();
    getMedico();
  }, []);

  const catchResponse = (status) => {
    if (status) {
      if (status === 401) {
        if (document.getElementById('btn_limpar')) {
          document.getElementById('btn_limpar').click();
        }
        handleInfo('Sessão expirada.');
        history.push('/login');
      }
    }
    handleError('Ocorreu um erro inesperado na execução desta operação');
  };

  const getFilaEspera = () => {
    api
      .get('api/filas?med_id=' + sessionStorage.getItem('med_id'), {
        headers: {
          Authorization: 'bearer ' + sessionStorage.getItem('token'),
          tcdocpw: sessionStorage.getItem('senha'),
          tcdocuserlogin:
            sessionStorage.getItem('cargo') === 'M'
              ? sessionStorage.getItem('med_email')
              : sessionStorage.getItem('secretaria_email'),
        },
      })
      .then((response) => {
        setFilaEspera(response.data);
        setArrayFiltrado(response.data);
        setTotalPages(response.data.length);
        var inicio = 0;
        var fim = 10;
        if (fim > response.data.length) {
          fim = response.data.length;
        }

        const usuarioPag = [];
        for (let i = inicio; i < fim; i++) {
          usuarioPag.push(response.data[i]);
        }
        setFilaEsperaPag(usuarioPag);
      })
      .catch((error) => {
        if (error.response) {
          catchResponse(error.response.status);
        }
      });
  };
  const handleChange = (medico) => {
    sessionStorage.setItem('med_id', medico.value);
    setStatusFila_espera_med_id(medico);
  };
  const getMedico = () => {
    let parametro = '?secretaria=' + sessionStorage.getItem('secretaria_id');
    const medicoArray = [];

    if (sessionStorage.getItem('cargo') === 'M') {
      setStatusFila_espera_med_id({
        label: sessionStorage.getItem('med_nome'),
        value: sessionStorage.getItem('med_id'),
      });
      medicoArray.push({
        label: sessionStorage.getItem('med_nome'),
        value: sessionStorage.getItem('med_id'),
      });

      setFila_espera_med(medicoArray);
    } else {
      api
        .get('api/medicos' + parametro, {
          headers: {
            Authorization: 'bearer ' + sessionStorage.getItem('token'),
            tcdocpw: sessionStorage.getItem('senha'),
            tcdocuserlogin:
              sessionStorage.getItem('cargo') === 'M'
                ? sessionStorage.getItem('med_email')
                : sessionStorage.getItem('secretaria_email'),
          },
        })
        .then((response) => {
          for (let i = 0; i < response.data.length; i++) {
            medicoArray.push({
              label: response.data[i].med_nome,
              value: response.data[i].med_id,
            });
          }
          setStatusFila_espera_med_id(medicoArray);
        })
        .catch((error) => {
          if (error.response) {
            catchResponse(error.response.status);
          }
        });
    }
  };
  const editar = (filaEspera) => {
    document.getElementById('fila_espera_pac_nome').focus();

    setFila_espera_id(filaEspera.fila_espera_id);
    setFila_espera_hora_ini(filaEspera.fila_espera_hora_ini);
    setFila_espera_hora_fim(filaEspera.fila_espera_hora_fim);
    setFila_espera_contato(filaEspera.fila_espera_contato);
    setFila_espera_observacao(filaEspera.fila_espera_observacao);
    setFila_espera_med({
      value: filaEspera.fila_espera_med_id,
      label: filaEspera.med_nome,
    });
    setFila_espera_pac_nome(filaEspera.fila_espera_pac_nome);
  };

  const dadosModal = (nome, id) => {
    setNomeModal(nome);
    setIdModal(id);
  };
  const save = (e, metodo, status) => {
    e.preventDefault();
    e.stopPropagation();
    let data, method, url;
    if (metodo) {
      method = 'delete';
    } else {
      if (!fila_espera_id) {
        method = 'post';
        let existeCidade = filaEspera.findIndex(
          (val) => val.fila_espera_pac_nome === fila_espera_pac_nome,
        );
        if (existeCidade !== -1) {
          handleInfo('paciente já existente');
          return false;
        }
      } else {
        method = 'put';
      }
    }

    if (method === 'put') {
      data = {
        fila_espera_id: fila_espera_id,
        fila_espera_med_id: sessionStorage.getItem('med_id'),
        fila_espera_hora_ini: fila_espera_hora_ini,
        fila_espera_hora_fim: fila_espera_hora_fim,
        fila_espera_contato: fila_espera_contato,
        fila_espera_observacao: fila_espera_observacao,
        fila_espera_pac_nome: fila_espera_pac_nome,
      };
      url = 'api/filas/' + fila_espera_id;
    } else if (method === 'post') {
      data = {
        fila_espera_med_id: sessionStorage.getItem('med_id'),
        fila_espera_hora_ini: fila_espera_hora_ini,
        fila_espera_hora_fim: fila_espera_hora_fim,
        fila_espera_contato: fila_espera_contato,
        fila_espera_observacao: fila_espera_observacao,
        fila_espera_pac_nome: fila_espera_pac_nome,
      };
      url = 'api/filas';
    } else if (method === 'delete') {
      // url = url + "/" + idModal + "/" + status;
      url = 'api/filas/' + idModal;
      data = {
        id: idModal,
      };
      setNomeModal('');
      setIdModal('');
    }

    api({
      method: method,
      url: url,
      data: data,
      headers: {
        Authorization: 'bearer ' + sessionStorage.getItem('token'),
        tcdocpw: sessionStorage.getItem('senha'),
        tcdocuserlogin:
          sessionStorage.getItem('cargo') === 'M'
            ? sessionStorage.getItem('med_email')
            : sessionStorage.getItem('secretaria_email'),
      },
    })
      .then((response) => {
        handleSuccess(response.headers.statusmessage);
        if (document.getElementById('btn_limpar')) {
          document.getElementById('btn_limpar').click();
        }
        getFilaEspera();
      })
      .catch((error) => {
        //  catchResponse();

        catchResponse(error.response.status);
        console.log(error);
      });
  };

  const limpar = () => {
    setFila_espera_id('');
    setStatusFila_espera_med_id([]);
    setFila_espera_hora_ini('');
    setFila_espera_hora_fim('');
    setFila_espera_contato('');
    setFila_espera_observacao('');
    setFila_espera_pac_nome('');

    setNomeModal('');
    setIdModal('');
  };
  const buscar = async () => {
    let filtrado, filtradoExame;

    if (arrayFiltrado) {
      if (!busca) {
        filtrado = filaEspera;
      } else {
        filtrado = arrayFiltrado.filter(function (obj) {
          return sqlLIKE(obj.fila_espera_pac_nome, '%' + busca + '%');
          // return ilikeToRegExp('%' + busca + '%').test(obj.exa_descricao);
        });

        filtradoExame = arrayFiltrado.filter(function (obj) {
          return sqlLIKE(obj.med_nome, '%' + busca + '%');
          //    return ilikeToRegExp('%' + busca + '%').test(obj.med_nome);
        });
        filtrado = filtrado.concat(filtradoExame);

        filtrado = filtrado.filter(function (a) {
          return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
        }, Object.create(null));
      }
      var inicio = 0 * rowsPerPage + 1;
      var fim = inicio + rowsPerPage - 1;
      if (!filtrado.length) {
        filtrado = filaEspera;
        handleInfo('Nenhum registro encontrado.');
      }
      if (fim > filtrado.length) {
        fim = filtrado.length;
      }
      const cidadePag = [];
      for (let i = inicio - 1; i < fim; i++) {
        cidadePag.push(filtrado[i]);
      }

      await setFilaEsperaPag(cidadePag);
      await setTotalPages(filtrado.length);
      await setArrayFiltrado(filtrado);
      await setPage(0);
    } else {
      handleInfo('Nenhum registro encontrado');
    }
  };
  return (
    <>
      <div className="container-fluid">
        <div
          className="modal fade bd-example-modal-lg"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="myLargeModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="card ">
                <div className="card-header">
                  {' '}
                  {FileMedicalAlt} Cadastro da fila de espera {AngleDoubleLeft}
                </div>

                <div id="triangulo-para-baixo"></div>
                <div className="card-body">
                  <form id="form_filaEspera" onSubmit={(e) => save(e)}>
                    <div className="form-row mb-3">
                      <div className="col-md-6 col-sm-6 col-12 mb-3">
                        <label htmlFor="fila_espera_pac_nome">
                          Paciente:
                          <strong className="fild-required">*</strong>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="fila_espera_pac_nome"
                          placeholder="Digite o nome do paciente"
                          onChange={(e) =>
                            setFila_espera_pac_nome(
                              e.target.value.toUpperCase(),
                            )
                          }
                          value={fila_espera_pac_nome}
                          required
                        />
                      </div>

                      <div className="col-md-3 col-6 mb-3">
                        <label htmlFor="fila_espera_hora_ini">
                          Hora inicial:
                          <strong className="fild-required">*</strong>
                        </label>
                        <input
                          type="time"
                          className="form-control"
                          id="fila_espera_hora_ini"
                          onChange={(e) =>
                            setFila_espera_hora_ini(e.target.value)
                          }
                          value={fila_espera_hora_ini}
                          required
                        />
                      </div>
                      <div className="col-md-3 col-6 mb-3">
                        <label htmlFor="fila_espera_hora_fim">
                          Hora final:
                          <strong className="fild-required">*</strong>
                        </label>
                        <input
                          type="time"
                          className="form-control"
                          id="fila_espera_hora_fim"
                          onChange={(e) =>
                            setFila_espera_hora_fim(e.target.value)
                          }
                          value={fila_espera_hora_fim}
                          required
                        />
                      </div>
                      <div className="col-md-4 col-sm-6 col-12 mb-3">
                        <label htmlFor="fila_espera_contato">
                          Contato:
                          <strong className="fild-required">*</strong>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="fila_espera_contato"
                          placeholder="celular com DDD"
                          maxLength="20"
                          onChange={(e) =>
                            setFila_espera_contato(
                              mask_tel_celular_area(e.target.value),
                            )
                          }
                          value={fila_espera_contato}
                          required
                        />
                      </div>
                      <div className="col-md-4  col-12 mb-3">
                        <label htmlFor="medico">
                          Médico:
                          <strong className="fild-required">*</strong>
                        </label>
                        <Select
                          id="medico"
                          value={fila_espera_med}
                          onChange={handleChange}
                          options={statusFila_espera_med_id}
                          placeholder={<div>Selecione</div>}
                        />
                        <input
                          style={{
                            top: '43px',
                            position: 'absolute',
                            zIndex: '-1',
                            width: '10%',
                          }}
                          type="password"
                          id="exa_medico_html5_validate"
                          value={fila_espera_med}
                          required
                        />
                      </div>
                      <div className="col-md-12 mb-3">
                        <div className="form-group">
                          <label htmlFor="cons_texto">
                            <b>Descrição:</b>
                          </label>
                          <textarea
                            className="form-control textarea-responsive"
                            id="cons_texto"
                            required="required"
                            type="text"
                            value={fila_espera_observacao}
                            onChange={(e) =>
                              setFila_espera_observacao(
                                e.target.value.toUpperCase(),
                              )
                            }
                            rows="7"
                            cols="120"
                          ></textarea>
                        </div>{' '}
                      </div>
                    </div>
                    <div className="text-left ">
                      {fila_espera_id ? (
                        <button
                          className="btn btn-sm btn_Cadastrar "
                          type="submit"
                          id="btnAlterar"
                        >
                          {Edit} Alterar
                        </button>
                      ) : (
                        <button
                          className="btn btn-sm btn_Cadastrar "
                          type="submit"
                          id="btnCadastrar"
                        >
                          {Save} Cadastrar
                        </button>
                      )}
                      &nbsp;&nbsp;{' '}
                      <button
                        className="btn btn-sm btn-secondary "
                        onClick={(e) => limpar(e)}
                        type="button"
                        data-dismiss="modal"
                        aria-label="Close"
                        id="btn_limpar"
                      >
                        {Times} Fechar
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            {' '}
            {FileMedicalAlt} Fila de espera {AngleDoubleLeft}
          </div>

          <div id="triangulo-para-baixo"></div>
          <div className="card-body ">
            <form>
              <div className="form-group">
                <div className="form-row">
                  <div className="col-md-5 col-12">
                    <div className="row">
                      <div
                        className="col-md-10 col-12 col-sm-12"
                        style={{ paddingRight: '0px' }}
                      >
                        <label htmlFor="filtro">Filtrar Tabela:</label>

                        <div
                          class="input-group mb-3"
                          style={{ position: 'relative', right: '50px' }}
                          onClick={(e) => buscar()}
                        >
                          <div class="input-group-prepend">
                            <span
                              style={{
                                display: 'inline',
                                borderRadius: '50px',
                                background: '#a7c4d2 ',
                                color: 'white',
                                position: 'relative',
                                right: '-37px',
                                zIndex: '99',
                              }}
                              class="input-group-text"
                              id="basic-addon1"
                            >
                              {Search}
                            </span>
                          </div>
                          <input
                            id="filtro"
                            className="form-control"
                            style={{
                              display: 'inline',
                              padding: '7px 29px 7px 52px',
                              borderRadius: '50px 0px 0px 50px',
                              borderBottom: '6px solid #a7c4d2 ',
                            }}
                            type="text"
                            onChange={(e) =>
                              setBusca(removeAcento(e.target.value))
                            }
                            value={busca}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-2">
                    <label htmlFor="btn_Cadastrar">&nbsp;&nbsp;&nbsp;</label>
                    <br />
                    <button
                      type="button"
                      className="btn  btn_Cadastrar btn-block "
                      id="btn_Cadastrar"
                      onClick={(e) => limpar(e)}
                      data-toggle="modal"
                      data-target=".bd-example-modal-lg"
                    >
                      {Save} Cadastrar
                    </button>
                  </div>
                  <div className="col-md-2 mb-3">
                    <label>&nbsp;&nbsp;&nbsp;&nbsp; </label>
                    <button
                      className="btn btn_Cadastrar  btn-block "
                      style={{ width: '200px' }}
                      onClick={(e) => history.push('/consulta')}
                    >
                      {AngleDoubleLeft} Voltar ao calendario
                    </button>
                  </div>
                  <div className="col-md-6"></div>
                </div>
              </div>
            </form>

            <div className=" table-responsive">
              <table className="table  table-hover table-striped table-light ">
                <thead className="text-white  bg-dark ">
                  <tr>
                    <th style={{ width: '90%' }} scope="col">
                      Nome
                    </th>

                    <th style={{ width: '10%' }} scope="col">
                      Ações
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filaEsperaPag.length > 0 ? (
                    filaEsperaPag.map(function (filaEsperas, i) {
                      return (
                        <>
                          <tr key={filaEsperas.fila_espera_id}>
                            <th>
                              {filaEsperas.fila_espera_pac_nome}
                              <br />
                              <p style={{ fontSize: '12px' }}>
                                {' '}
                                <i>{filaEsperas.fila_espera_contato}</i>
                                <br />
                                <i>{filaEsperas.med_nome}</i>
                                <br />
                                <i>
                                  Horário:
                                  {' ' +
                                    filaEsperas.fila_espera_hora_ini.substring(
                                      0,
                                      5,
                                    )}{' '}
                                  -{' '}
                                  {filaEsperas.fila_espera_hora_fim.substring(
                                    0,
                                    5,
                                  )}
                                </i>{' '}
                                <br />
                                <i>
                                  {'Data: ' +
                                    mask_data(filaEsperas.fila_espera_date_cad)}
                                </i>
                              </p>
                            </th>

                            <td>
                              <img
                                src="alterar.png"
                                onClick={(e) => editar(filaEsperas)}
                                className="btn-acao mb-2 mr-2"
                                data-toggle="modal"
                                data-target=".bd-example-modal-lg"
                              />
                              <img
                                src="excluir.png"
                                onClick={(e) =>
                                  dadosModal(
                                    filaEsperas.fila_espera_pac_nome,
                                    filaEsperas.fila_espera_id,
                                  )
                                }
                                className="btn-acao mb-2 mr-2"
                                data-toggle="modal"
                                data-target="#exampleModalCenter"
                              />
                            </td>
                          </tr>
                        </>
                      );
                    })
                  ) : (
                    <>
                      <tr>
                        <th>Nenhum registro foi encontrado</th>

                        <th></th>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
              <TablePagination
                component="div"
                count={totalPages}
                page={page}
                onChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
                labelRowsPerPage={'Registros por página'}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalCenter"
        tabIndex="1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="card card-red">
              <div className="card-header">{Trash} Excluir Paciente</div>

              <div className="card-body">
                Tem certeza que deseja excluir da fila de espera o paciente{' '}
                <i>
                  <b className="text-danger">"</b>
                  {nomeModal}
                  <b className="text-danger">"</b>
                </i>{' '}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-sm btn-secondary "
                  type="button"
                  data-dismiss="modal"
                >
                  {Times}
                  &nbsp;Cancelar
                </button>
                &nbsp;&nbsp;
                <button
                  className="btn btn-sm btn_excluir "
                  onClick={(e) => save(e, 'delete', 0)}
                  type="button"
                  data-dismiss="modal"
                >
                  {Trash} Excluir
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default FilaEspera;
